module.exports = __webpack_public_path__ + "static/media/area b.8af4b41c.jpg";